var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContactsGreyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "contacts"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4341_50399",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4341_50399)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contacts_2",
    d: "M4.5 21.3846V20.3846H19.5V21.3846H4.5ZM4.5 3.61537V2.61537H19.5V3.61537H4.5ZM12 14C12.6923 14 13.2821 13.7564 13.7692 13.2692C14.2564 12.782 14.5 12.1923 14.5 11.5C14.5 10.8077 14.2564 10.2179 13.7692 9.73075C13.2821 9.24358 12.6923 9 12 9C11.3077 9 10.7179 9.24358 10.2308 9.73075C9.74359 10.2179 9.5 10.8077 9.5 11.5C9.5 12.1923 9.74359 12.782 10.2308 13.2692C10.7179 13.7564 11.3077 14 12 14ZM4.61538 19C4.15513 19 3.77083 18.8458 3.4625 18.5375C3.15417 18.2292 3 17.8449 3 17.3846V6.61537C3 6.15512 3.15417 5.77083 3.4625 5.4625C3.77083 5.15416 4.15513 5 4.61538 5H19.3846C19.8449 5 20.2292 5.15416 20.5375 5.4625C20.8458 5.77083 21 6.15512 21 6.61537V17.3846C21 17.8449 20.8458 18.2292 20.5375 18.5375C20.2292 18.8458 19.8449 19 19.3846 19H4.61538ZM7.05768 18C7.80768 17.3231 8.59422 16.8205 9.4173 16.4923C10.2404 16.1641 11.1013 16 12 16C12.8987 16 13.7596 16.1641 14.5827 16.4923C15.4058 16.8205 16.1923 17.3231 16.9423 18H19.3846C19.5385 18 19.6795 17.9359 19.8077 17.8077C19.9359 17.6795 20 17.5385 20 17.3846V6.61537C20 6.46154 19.9359 6.32051 19.8077 6.1923C19.6795 6.0641 19.5385 6 19.3846 6H4.61538C4.46154 6 4.32052 6.0641 4.1923 6.1923C4.0641 6.32051 4 6.46154 4 6.61537V17.3846C4 17.5385 4.0641 17.6795 4.1923 17.8077C4.32052 17.9359 4.46154 18 4.61538 18H7.05768ZM8.7 18H15.3C14.8167 17.6667 14.2958 17.4167 13.7375 17.25C13.1792 17.0833 12.6 17 12 17C11.4 17 10.8208 17.0833 10.2625 17.25C9.70417 17.4167 9.18333 17.6667 8.7 18ZM12 13C11.5885 13 11.2356 12.8529 10.9413 12.5586C10.6471 12.2644 10.5 11.9115 10.5 11.5C10.5 11.0884 10.6471 10.7356 10.9413 10.4413C11.2356 10.1471 11.5885 10 12 10C12.4115 10 12.7644 10.1471 13.0587 10.4413C13.3529 10.7356 13.5 11.0884 13.5 11.5C13.5 11.9115 13.3529 12.2644 13.0587 12.5586C12.7644 12.8529 12.4115 13 12 13Z",
    fill: "#A3A3A3"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactsGreyIcon);
export default __webpack_public_path__ + "static/media/contacts-grey-icon.24aec4dd1081dbc6c471c5ee6504434b.svg";
export { ForwardRef as ReactComponent };